import { useState, useMemo } from 'react';
import { useDebounce } from './useDebounce';

// Custom Hook
export const useFilteredAndSortedQRs = (activeQRs) => {

    const [ filters, setFilters ] = useState({
        searchValue: '',
        categoryValue: '',
        searchType: 'name',
        sortBy: '',
    });
    const { categoryValue, searchType, searchValue, sortBy } = filters;

    const debouncedSearchValue = useDebounce(searchValue, 300);

    const filteredAndSortedArr = useMemo(() => {
        let currentArr = [...activeQRs?.filter(qr => !qr?.data?.linked_qr) || []];

        if (categoryValue) {
            currentArr = currentArr.filter(obj => obj.data?.category && obj.data.category === categoryValue);
        }

        if (debouncedSearchValue?.length > 0) {
            if (searchType === 'name') {
                currentArr = currentArr.filter(obj => obj.data?.nickname?.toLowerCase().includes(debouncedSearchValue.toLowerCase()));
            } else if (searchType === 'tag') {
                currentArr = currentArr.filter(obj => {
                    if (obj.data?.tags?.length > 0) {
                        const tempArr = obj.data.tags.filter(tag => tag.toLowerCase().includes(debouncedSearchValue.toLowerCase()));
                        return tempArr.length > 0;
                    }
                    return false;
                });
            }
        }

        let sortedArr = [...currentArr];

        switch (sortBy) {
            case 'newest':
                sortedArr.sort((a, b) => {
                    const dateA = new Date(a.data?.created_at || '1970-01-01T00:00:00.000Z');
                    const dateB = new Date(b.data?.created_at || '1970-01-01T00:00:00.000Z');
                    return dateB.getTime() - dateA.getTime() ||
                           a.data?.nickname?.toLowerCase().localeCompare(b.data?.nickname?.toLowerCase() || '');
                });
                break;
            case 'oldest':
                sortedArr.sort((a, b) => {
                    const dateA = new Date(a.data?.created_at || '1970-01-01T00:00:00.000Z');
                    const dateB = new Date(b.data?.created_at || '1970-01-01T00:00:00.000Z');
                    return dateA.getTime() - dateB.getTime() ||
                           b.data?.nickname?.toLowerCase().localeCompare(a.data?.nickname?.toLowerCase() || '');
                });
                break;
            case 'alpha-asc':
                sortedArr.sort((a, b) => 
                    a.data?.nickname?.toLowerCase().localeCompare(b.data?.nickname?.toLowerCase() || '')
                );
                break;
            case 'alpha-des':
                sortedArr.sort((a, b) => 
                    b.data?.nickname?.toLowerCase().localeCompare(a.data?.nickname?.toLowerCase() || '')
                );
                break;
            default:
                if (sortBy) {
                    sortedArr = sortedArr.filter(qr => qr.data?.qr_type === sortBy);
                    sortedArr.sort((a, b) => 
                        b.data?.nickname?.toLowerCase().localeCompare(a.data?.nickname?.toLowerCase() || '')
                    );
                } else {
                    sortedArr.sort((a, b) => 
                        a.data?.nickname?.toLowerCase().localeCompare(b.data?.nickname?.toLowerCase() || '')
                    );
                }
                break;
        }

        return sortedArr;
    }, [activeQRs, sortBy, categoryValue, debouncedSearchValue, searchType]);

    return [filters, setFilters, filteredAndSortedArr];
};